export const LOAD_ORDER_DETAIL_DATA = 'orderDetail/LOAD_ORDER_DETAIL_DATA';
export const SET_ORDER_DETAIL_STATUS = 'orderDetail/SET_ORDER_DETAIL_STATUS';
export const SET_ORDER_DETAIL_DATA = 'orderDetail/SET_ORDER_DETAIL_DATA';